import React, { useEffect, useLayoutEffect, useState } from "react";

import "../../Styles/globalStyle.css";
import TreeViewDialog from "../../TreeViewDialog/TreeViewDialog";
import useGetValueFromArray from "../../../Hooks/useGetValueFromArray.js";
import EditorStyles from "./EditorStyles";
import "./RichTextEditor.css";

export default function RichTextEditor(props) {
  const getValueFromArray = useGetValueFromArray();
  var currentSelection = undefined
  
  var newHref = undefined
 
  var isCtrlAPressed = false;
  const bufferSize = 100
  const deletekeyCode = 46
  const backspacekeyCode = 8
  const validationKeyCode = 13
  const ctrlkeyCode = 17
  const akeyCode = 65
  const xkeyCode = 88
  const ykeyCode = 89
  const zkeyCode = 90
  const arobasekeyCode = 50
  const variableStyleId = 99
  //const ContentId = "Content" + props.data.id
  const ContentId = "Editor" + props.data.id
  
  var replaceSize = {nline:0, firstLineLength:0, lastLineLength:0}

  const getInitialId = () => {
    return parseInt(props.data.id + "000000000")
  }
  
  const initialId = getInitialId()
  var curentRanges = null
  const [format, setFormat] = useState(props.format ? {...props.format, initialValue:true} : { 
    itemValue: {forceRender: false, selection: null, ranges: { currentId:initialId}
    
    , content: null, childs: [], currentLine:{}, scroll:{top: 0}, selectedsIds : [],
      font : { 
        fontFamily: {id : 1, default:"Arial", value:"Arial"},
        fontSize: {id : 2,  default: 12,  value: 12},
        color: {id : 3,  default:"Black",  value:"Black"},
      },
      urls : {nextId:1, data:[]}
    },
    isCtrlPressed:false,
    isPreviousEnabled:false,
    isNextEnabled:false,
    historical:{position: 0, itemValues:[]},
    isArobasePressed:false,
    
    fonts : { 
      types :[{ "id": 1, "item": "fontFamily" },{ "id": 2, "item": "fontSize" },{ "id": 3, "item": "color" }],
      fontFamily: {id : 1, values:[{ "id": 1, "item": "Arial" }, { "id": 2, "item": "Serif" }, { "id": 3, "item": "Tahoma" }, { "id": 4, "item": "Verdana" }]},
      fontSize: {id : 2, values:[{ "id": 1, "item": 10 },{ "id": 2, "item": 11 },{ "id": 3, "item": 12 },{ "id": 4, "item": 13 },{ "id": 5, "item": 14 },{ "id": 6, "item": 15 }]},
      color: {id : 3, values:[{ "id": 1, "item": "Black" }, { "id": 2, "item": "Red" }]},
    }
  });


  const [currentRangeValue, setCurrentRangeValue] = useState(curentRanges)

  var isCtrlPressed = format.isCtrlPressed;
  const spanId = -1
  const undoId = 11
  const redoId = 12
  const linkId = 13
  const breakLineId = 17
  const tabulationId = 18
  const deleteId = 19
  const liId = 20
  

  
  //var curentRanges = format.itemValue.ranges
  
  const typesToRemoveAfterFormated = [breakLineId,tabulationId,deleteId];
  const textAlignTypes = [7,8,9,10];
  const fontTypes = [14,15,16];
  const listStyleTypes = [5,6];
  const lineStyleTypes = [...textAlignTypes ];
  var alreadySetCurrentStyle = false;
  var isTypingText = false
  var keyCode = format.itemValue.ranges.keyCode
  var callBackDetails = format.itemValue.ranges.callBackDetails
  
  const removeCurrentLineListStyle = (line) => {
    
    if (curentRanges == null) setRange()
    var updatedFormat = JSON.parse(JSON.stringify(format));
    updatedFormat.itemValue.childs.filter(child => child.destination.line == line)
      .map(child => child.type = child.type.filter( type => !listStyleTypes.includes(type)) )
    updatedFormat.itemValue.selectedsIds = updatedFormat.itemValue.selectedsIds.filter(id => !listStyleTypes.includes(id))

    setUpdatedFormat(updatedFormat,updatedFormat.itemValue.childs,curentRanges,getAllContent().scrollTop)
    setFormatWithHistorical(updatedFormat)
  }

  const refreshHistoricalContent = (updatedFormat) => {
    updatedFormat.historical.itemValues.map((item, index) =>
      item.content = format.historical.itemValues[index].content)
  }
  const setHistorical = (updatedFormat) => {

    refreshHistoricalContent(updatedFormat)

    let n = updatedFormat.historical.itemValues.length 
    if (n == bufferSize) {
      updatedFormat.historical.itemValues.shift()
      n = n - 1
    }
    updatedFormat.historical.position = n 
    updatedFormat.historical.itemValues.push(updatedFormat.itemValue)
    
  }

  const setPrevious = () => {
    if (format.isPreviousEnabled) setCurrentFormat(-1)
  }

  const setCurrentFormat = (shift) => {
    const isPrevious = shift < 0
    const newPosition = format.historical.position + shift
    
    if (newPosition >= 0 && newPosition < bufferSize) {
      let updatedFormat = JSON.parse(JSON.stringify(format))
      refreshHistoricalContent(updatedFormat)


      if (isPrevious) {
        updatedFormat.isNextEnabled = true;
        if (newPosition == 0) 
          updatedFormat.isPreviousEnabled = false;
      }
      else {
        updatedFormat.isPreviousEnabled = true;
        if (newPosition + 1 == updatedFormat.historical.itemValues.length) 
          updatedFormat.isNextEnabled = false;
      }
      
      updatedFormat.isCtrlPressed = true;
      updatedFormat.historical.position = newPosition
      updatedFormat.itemValue = format.historical.itemValues[updatedFormat.historical.position]

      setFormat(updatedFormat)
    }
  }

  const setNext = () => {
    if (format.isNextEnabled) setCurrentFormat(1)
  }

  const saveValidation = () => {
    
    /*var selectionValue = buildSelection(startOffset = currentSelection.anchorNode.textContent.length, endOffset = currentSelection.focusNode.textContent.length)*/
      
    
      var selectionValue = buildSelection()
      
      var range = selectionValue.getRangeAt(0);
      var selectionPosition = getSelectionPosition(selectionValue)   
      var divTop =  getDivLineByLine(selectionPosition.start.line).div  
      
      var startOffset = getOffSetByLine(range.startOffset, selectionPosition.start.left, divTop.childNodes)
      var length = divTop.textContent.slice(startOffset).length
      var endOffset = startOffset + (length == 0 ? 1 : length)
      var rangeValue = { startOffset: startOffset, endOffset: endOffset 
        , start:selectionPosition.start, end:selectionPosition.end  }
      
      var rects = Object.entries(range.getClientRects()).map(rect => {
        var domRect = rect[1];
        rangeValue["addLine"] = domRect.height
        let currentLine = getDivByTop(domRect.top)
        return { top: getTopValue(domRect.top) , left: domRect.left, line:currentLine.line }
      });  
      rangeValue["rects"] = rects
      
      if (!rangeValue.addLine)
        rangeValue["addLine"] = currentSelection.anchorNode.getBoundingClientRect().height
   
      var parent = getAllContent();
      
      var newItem = undefined;
      var nexItem = undefined;
      var parentElement = divTop.parentElement
      if ((parentElement.tagName) == "LI") {
        if (parentElement.textContent != "") {
          nexItem = parentElement.nextSibling
          newItem = document.createElement("LI");
          newItem.appendChild(document.createElement("div"));
          parent = parentElement.parentElement
          newItem.childNodes[0].appendChild(document.createElement("span"));
          newItem.childNodes[0].setAttribute("id", `Line${props.data.id}${divTop.id}px`)
          newItem.childNodes[0].setAttribute("style", `display: flex; white-space: pre; min-height: ${rangeValue.addLine}px`)
        }else{
          removeCurrentLineListStyle(rangeValue.start.line)
          return
        }
      }else{
        nexItem = divTop.nextSibling
        newItem = document.createElement("div");
        newItem.appendChild(document.createElement("span"));
        newItem.setAttribute("id", `Line${props.data.id}${divTop.id}px`)
        newItem.setAttribute("style", `display: flex; white-space: pre; min-height: ${rangeValue.addLine}px`)
      }
      
      
      
      parent.insertBefore(newItem, nexItem)
      rangeValue["isCollapsed"] = false
      rangeValue["currentLine"] = selectionPosition.start.line + 1
    
      onClickItem({type:breakLineId}, rangeValue)
  }

  const setSelection = () => {
    
    if (format.itemValue.ranges) {    
      var anchorNode = null
      var focusNode = null
      var startOffset = null
      var endOffset = null   
      let content = getAllContent();
      let lines = getAllLines(content);

      if (format.itemValue.ranges.start) {

        
        let prevStartOffset = format.itemValue.ranges.startOffset
        let prevEndOffset = format.itemValue.ranges.endOffset
        let anchorNodeDiv = lines[format.itemValue.ranges.start.line];
        let focusNodeDiv = lines[format.itemValue.ranges.end.line];
        if (format.itemValue.ranges.isLinkLastPosition == true) {
          prevStartOffset = getOffSetByLine(format.itemValue.ranges.previousSelection.startOffset
            , format.itemValue.ranges.previousSelection.anchorNodeLeft, anchorNodeDiv.childNodes) + 1
          prevEndOffset = getOffSetByLine(format.itemValue.ranges.previousSelection.endOffset
            , format.itemValue.ranges.previousSelection.focusNodeLeft, focusNodeDiv.childNodes) + 1
        }
        
          
        let anchorNodeValue = getNodeByDivAndOffset(anchorNodeDiv, prevStartOffset)
        anchorNode = anchorNodeValue.div
        startOffset = anchorNodeValue.relativeOffset
        


        let focusNodeValue = getNodeByDivAndOffset(focusNodeDiv, prevEndOffset)
        focusNode = focusNodeValue.div
        endOffset = focusNodeValue.relativeOffset 
      }
      else
      {               
         
        var parent = format.itemValue.currentLine.line ? lines[format.itemValue.currentLine.line] : document.getElementById(format.itemValue.ranges.currentId) ; 
        var child = getLeafChild(parent);
        if (!child) child = parent       
        anchorNode = child
        focusNode = child
        startOffset = 0//child.textContent.length 
        endOffset = 0//child.textContent.length      
      }
      setCurrentRange(anchorNode,startOffset,focusNode,endOffset)
       
    }
   
  }

  const setCurrentRange= (anchorNode,startOffset,focusNode,endOffset) => {
    
    var range = document.createRange()
    var selection = window.getSelection()
    range.setStart(anchorNode, startOffset)
    range.setEnd(focusNode, endOffset)
    selection.removeAllRanges()
    selection.addRange(range)
    
    setRange(selection)
  }

  const buildSelection = (startOffset=undefined, endOffset=undefined) => {
    
    var range = document.createRange()
    var selection = window.getSelection()
    
    let anchorNodeLine = getDivLineById(getLine(currentSelection.anchorNode).id).line
    
    let focusNodeLine = getDivLineById(getLine(currentSelection.focusNode).id).line

    let anchorNodeLeft = currentSelection.anchorNode.parentElement.getBoundingClientRect().left
    let focusNodeLeft = currentSelection.focusNode.parentElement.getBoundingClientRect().left 
    
    let selectFromLeft = anchorNodeLine > focusNodeLine || 
    (anchorNodeLine == focusNodeLine && anchorNodeLeft > focusNodeLeft )
    
    if (selectFromLeft){
      
    
      range.setStart(currentSelection.focusNode, currentSelection.startOffset)
      range.setEnd(currentSelection.anchorNode, currentSelection.endOffset)
    }
    else
    {
      
      range.setStart(currentSelection.anchorNode, currentSelection.startOffset)
      range.setEnd(currentSelection.focusNode, currentSelection.endOffset)
    }   
    
    selection.removeAllRanges()
    selection.addRange(range)
   
    return selection
  }

  const getNodeByDivAndOffset = (div, left) => {
    
    let childByOffset = getChildByOffset(div, left) 
    
    let child = getLeafChild(childByOffset.div)  

    return {div: child, relativeOffset:childByOffset.relativeOffset}
  }

  const getLeafChild = (actualChild) => {
    
    

    if (!actualChild.innerHTML) return actualChild
    var searChedChild = Array.from(actualChild.childNodes).map(child => {
      
    
       return getLeafChild(child)
      }
    ) 
    return searChedChild.flat(Infinity)[0]
  }

 
  useLayoutEffect(() => {
    var content = getAllContent()
    const scrollTop = format.itemValue.scroll.top
    content.scrollTop = scrollTop  
   
  });

  
  useEffect(() => { 
    
    if(format.initialValue) {
      let childNodes = new DOMParser().parseFromString(format.itemValue.innerHTML, "text/html").getElementsByTagName("BODY")[0].childNodes
      document.getElementById(ContentId).childNodes.forEach(child => document.getElementById(ContentId).removeChild(child))
      let content = document.getElementById(ContentId)
      content.append(...childNodes) 
      setNext()
     
    } else {
      
      const callBackDetailsValue = format.itemValue.ranges.callBackDetails
      if(callBackDetailsValue) {
        callBackDetails = undefined
        let div = getDivLineByLine(callBackDetailsValue.line).div; 
        var detail =  getLeafChildByPosition({child:div, position:callBackDetailsValue.startOffset + 1 , line : callBackDetailsValue.line}) // le + 1 permet de se positionnener sur le deuxieme char et de prendre le bon noeud
        let startOffset = format.itemValue.selectedsIds.length > 0 ? 0: (detail.position - 1) // -1 pour revenir à la premeiere position
        if(startOffset < 0) startOffset = 0
        let endOffset = startOffset + callBackDetailsValue.length   //position base zéro
        
        setCurrentRange(detail.child, startOffset, detail.child, endOffset) 
        onClickStyleItem (callBackDetailsValue.parameters, curentRanges, callBackDetailsValue.parameters.checkedDetail)
      } else onSaveEdition({...format})
      
    }
    setSelection()
  }, [format.itemValue.forceRender])

  const getLine = (item) => {
    if (item.tagName == 'DIV') {
      return item
    }
    else
      return getLine(item.parentElement)
  }

  const getFirstChildDiv =(parent)=>{
    let node = parent.childNodes[0]
    if (node.tagName == 'DIV')
      return node

    return getFirstChildDiv(node)
  }
  const getSelectionPosition = (selection) => {
    var anchorOffset = selection.anchorOffset
    var focusOffset = selection.focusOffset
    
    
    var firstNode = selection.anchorNode
    var lastNode = selection.focusNode
   
   

    if (firstNode.id == ContentId)
      firstNode = getFirstChildDiv(getAllContent()) //getAllContent().childNodes[0]
    else if (firstNode.tagName != 'DIV') {
      
      firstNode = firstNode.parentElement
      
    }
    if (lastNode.id == ContentId)
      lastNode = getFirstChildDiv(getAllContent()) //getAllContent().childNodes[0]
    else if (lastNode.tagName != 'DIV') {
      lastNode = lastNode.parentElement
    }
    
    
    
    var posFistNode = firstNode.getBoundingClientRect()
    var posLastNode = lastNode.getBoundingClientRect()
    var start = null
    var end = null
    
    let posFistNodeTop = getTopValue(posFistNode.top)
    let posLastNodeTop = getTopValue(posLastNode.top)
    
    let firstLine = getDivLineById(getLine(firstNode).id)
    let lastLine = getDivLineById(getLine(lastNode).id)

    
    
    /*
    let firstLine = getDivLineById(firstNode.id)
    let lastLine = getDivLineById(lastNode.id)
*/

    if ( firstLine.line == lastLine.line) {
      if (posFistNode.left <= posLastNode.left) {
        start = {top: posFistNodeTop, left : posFistNode.left, line: firstLine.line}
        end = {top: posLastNodeTop, left : posLastNode.left, line: lastLine.line}
      } else {
        start = {top: posLastNodeTop, left : posLastNode.left, line: lastLine.line}
        end = {top: posFistNodeTop, left : posFistNode.left, line: firstLine.line}
      }
    }
    else if (firstLine.line < lastLine.line) {
      start = {top: posFistNodeTop, left : posFistNode.left, line: firstLine.line}
      end = {top: posLastNodeTop, left : posLastNode.left, line: lastLine.line}
    }
    else if (firstLine.line > lastLine.line) {
      start = {top: posLastNodeTop, left : posLastNode.left, line: lastLine.line}
      end = {top: posFistNodeTop, left : posFistNode.left, line: firstLine.line}
    }
    
    return {start: start, end : end, firstLine:firstLine}
  }
 
  const getRangeValue = (range, selection) => {
       
    
    var selectionPosition = getSelectionPosition(selection)
    
    
    let startLine = getDivLineByLine(selectionPosition.start.line); 
    let endLine = getDivLineByLine(selectionPosition.end.line);
    
    
    
    var startOffset = getOffSetByLine(range.startOffset, selectionPosition.start.left, startLine.div.childNodes)
    var endOffset = getOffSetByLine(range.endOffset, selectionPosition.end.left, endLine.div.childNodes)  
    var rangeValue = { startOffset: startOffset, endOffset: endOffset
      , start:selectionPosition.start, end:selectionPosition.end 
    }
        
    rangeValue["nChar"] = {start:startLine.div.textContent.length, end:endLine.div.textContent.length}
    rangeValue["keyCode"] = keyCode
    rangeValue["callBackDetails"] = callBackDetails
    
    return rangeValue
  }

  const setRange = (selection=undefined, currentEvent=undefined) => {
    
    var content = getAllContent()
    if (!content.innerHTML || content != document.activeElement) return
    if(!selection) {
      setCurrentSelection()
      
      selection = buildSelection();
    }
    
    var range = selection.getRangeAt(0);
    var rects = []
    
    var rangeValue = getRangeValue(range, selection)
    rects = [...rects, ...Object.entries(range.getClientRects()).map(rect => {
      var domRect = rect[1];

      let currentLine = getDivByTop(domRect.top)
      return { top: getTopValue(domRect.top), left: domRect.left, line: currentLine.line  }
    })];  
    
    rangeValue["rects"] = rects
    rangeValue["addLine"] = 0
    rangeValue["isCollapsed"] = selection.isCollapsed
    rangeValue["nLine"] = getAllLines(content).length
    
    curentRanges = rangeValue
   
    setCurrentRangeValue(curentRanges)
  }

  const getChildByOffset = (parent, offset) => {
    let divs = Array.from(parent.childNodes)
    let div = null
    let n = divs.length
    let contentLength = 0
    let prevLength = 0
    let i = 0 
    let found = false;
    let relativeOffset = 0
    
    if (n ==0) 
      div = parent
    while (i < n && !found) {
      let actualLength = divs[i].textContent.length
      
      contentLength = prevLength + actualLength
      if (contentLength >= offset)  {
        found = true
        div = divs[i]
        relativeOffset = offset - prevLength
      }
      prevLength = contentLength
      i = i + 1
    }   
    
    return {div: div, relativeOffset:relativeOffset}
  } 
  const isInCurrentLine = (line, top) => {
    
    let rect = line.getBoundingClientRect()
   
    return getTopValue(rect.top) <= top && (rect.height == 0 || top < getTopValue(rect.bottom))
  } 

  const getDivByTop = (top) => {
  
    var content = getAllContent()
    
    var divs = content.querySelectorAll("div")
    /*var divs = Array.from(content.childNodes)*/
    
    
    var div = null
    var n = divs.length
    
    var i = 0 
    var found = false;
    let line = undefined
    while (i < n && !found) {
      
      if(isInCurrentLine(divs[i], getTopValue(top))) {
        found = true
        div = divs[i]
        line = i;
      }
      i = i + 1
    }  
    
        
    /*
    if (!div)
      div = content
      */
    return {div: div, line:line}
  } 


  const getDivLineById = (id) => {
    var content = getAllContent()
    var divs = content.querySelectorAll("div")
    var div = null
    var n = divs.length
    var i = 0 
    var found = false;
    let line = undefined
    while (i < n && !found) {
      
      if(divs[i].id == id) {
        found = true
        div = divs[i]
        line = i;
      }
      i = i + 1
    }  
    return {div: div, line:line}
  } 

  const getDivLineByLine = (numLine) => {
    var content = getAllContent()
    var divs = content.querySelectorAll("div")
    var div = null
    var n = divs.length
    var i = 0 
    var found = false;
    let line = undefined
    while (i < n && !found) {
      
      if(i == numLine) {
        found = true
        div = divs[i]
        line = i;
      }
      i = i + 1
    }  
    return {div: div, line:line}
  } 


  const getOffSetByLine = (rangeOffset, actualLeft, childNodes) => {
    
    var n = childNodes.length
    var i = 0
    var found = false
    var offset = 0
    var currentSize = 0
   
    
    while (i < n && !found) {
      var node = childNodes[i] 
      i = i + 1   
      if (node.innerHTML) {
        var clientRect = node.getBoundingClientRect()
        
        if (clientRect.left > actualLeft)      
          found = true
        else{
         
          currentSize = node.textContent.length
          offset = offset + currentSize
          
        }
      } 
    
    }
   
    return rangeOffset + (offset - currentSize)
  }

  /*const getChildByLineAndPositionIfDeleteReturnPrevious = (line, position) => {
    let lines = getAllLines(getAllContent()) 
    let childNodes = lines[line == lines.length ? line -1 : line].childNodes
    var n = childNodes.length
    var i = 0
    var div = undefined
    var currentSize = 0
    
    while (i < n && !div) {
      var node = childNodes[i] 
      i = i + 1   
      currentSize = currentSize + node.textContent.length
      if (currentSize >= position)      
        div = node
    }
   
    return getLeafChild(div)
  }*/

  const getChildByLineAndPositionIfDeleteReturnPrevious = (line, position) => {
    let lines = getAllLines(getAllContent()) 
    let currentLinePosition = line == lines.length ? line -1 : line
    let child = lines[currentLinePosition]
    
    var detail = {child:child, position:position, line : currentLinePosition, prevLength:child.textContent.length}
    
    
    
    return  getLeafChildByPosition(detail)
  }


  const getLeafChildByPosition = (detail) => {
    
    const childNodes = detail.child.childNodes
    var n = childNodes.length
    var i = 0
    var div = undefined
    var currentSize = 0
    if (n == 0) return detail
    
    while (i < n) {
      var node = childNodes[i] 
      
      i = i + 1   
      
      let nodeTextLength = node.textContent.length
      let prevSize = currentSize
      currentSize = currentSize + nodeTextLength
      if (currentSize > detail.position)  {   
        let newPosition =  detail.position - prevSize
        if (newPosition  < 0) {
          let lines = getAllLines(getAllContent())
          let currentLine = detail.line == lines.length ? detail.line -1 : detail.line
          node = lines[currentLine]
          detail = {...detail, child:node, line: currentLine,position:currentSize}
        }
        else {
          
          detail = {...detail, child:node,position:  newPosition}
          
        }
        
        if (detail.child.innerHTML) return getLeafChildByPosition(detail)
      } else if (currentSize == detail.position)  {    
        
        detail = {...detail, child:node,position: nodeTextLength}
        if (detail.child.innerHTML) return getLeafChildByPosition(detail)
      }
    }
    
    return detail
  }

  const getIntialRange =()=> {
    var selectionValue = window.getSelection()
    var range = selectionValue.getRangeAt(0);
    
    var rectsValue = Object.entries(range.getClientRects()).map(rect => {
      var domRect = rect[1];
      return { top: getTopValue(domRect.top), left: domRect.left, addLine: 0 }
    });
      
    var ranges = {
      isCollapsed: range.isCollapsed, startOffset: range.startOffset
      , endOffset: range.endOffset, rects: rectsValue
    }

    return ranges
  }

  const getAllContent  = (e) => {
   return  document.getElementById(ContentId);
  }
  const getAllLines = (content) => {
    return  content.querySelectorAll("div");
  } 

  const isLineUpOrBottomSelection  = (child, startLine, endLine) => {
    return (child.destination.line < startLine || child.destination.line > endLine)  
  } 

  const isSameLineAndInnerSelection  = (sameLigne, child, startLine, startOffset ,shiftStartLength) => {

    return (sameLigne && child.destination.line == startLine && 
              ( // mêmes lignes internes suprprimer les éléments internes
                (isListOrLineStyle(child.type) && 
                  (startOffset >= 0)
                )
                || 
                (!isListOrLineStyle(child.type) && 
                  (child.start < startOffset || child.start >= startOffset + shiftStartLength)
                )
              )  
            )  
  } 

  const isNotSameLineAndInnerSelection  = (sameLigne, child, startLine, startOffset, endLine, endOffset) => {
    return !sameLigne && (
      (isListOrLineStyle(child.type) &&
         ( 
           child.destination.line == startLine  // Ne pas supprimer les lines styles ici ils seront supprimes plus bas
           /*||  
           child.destination.line == endLine*/)  // Ne pas supprimer les lines styles ici ils seront supprimes plus bas
       )
     ||
     (!isListOrLineStyle(child.type) && 
       (
         ( child.destination.line == startLine && child.start < startOffset) // différentes lignes garder le syle de la premier ligne a gauche 
         || 
         (child.destination.line == endLine && child.end > endOffset) // différentes lignes garder le syle a droite de la derniere ligne 
       )
     )
   )
  } 
  
  const deleteIfNeeded = (updatedFormat, event) => {
       
      let content = getAllContent()   
      let lines = getAllLines(content)      
      let startLine = curentRanges.start.line
      let startOffset = curentRanges.startOffset 
      let endLine = curentRanges.end.line
      let endOffset = curentRanges.endOffset
      let sameLigne = startLine == endLine
      let samePosition = startOffset == endOffset
      
      let rowDecalage = curentRanges.nLine - lines.length 
      
      if (keyCode == backspacekeyCode && sameLigne && samePosition) {
        startOffset = startOffset -1
        endOffset = endOffset - 1
      }
      
      let shiftStartLength = 0
      // décallage last line for sameLigne and not sameLigne
      let colDecalage = startOffset - endOffset
      //let currentLine = endLine == 0 ? 0 : endLine - rowDecalage  // base 0 for endLine
      
      
      if (sameLigne) {
        //let actualLine = undefined
        if (rowDecalage > 0) {   
          let currentLine = endLine == 0 ? 0 : endLine - rowDecalage  // base 0 for endLine 
          let actualLine = getDivLineByLine(currentLine).div
          colDecalage = actualLine.textContent.length - curentRanges.nChar.start
        }
        
        if (rowDecalage== 0)  {
          //actualLine = getDivLineByLine(startLine).div
          
          shiftStartLength = curentRanges.nChar.start - event.target.textContent.length //actualLine.textContent.length         //+ (curentRanges.startOffset - startOffset)
          if (samePosition) 
            colDecalage = -1
          else
          colDecalage = colDecalage + replaceSize.firstLineLength
        }
         
     }
     
     
     
     
     updatedFormat.itemValue.childs = updatedFormat.itemValue.childs
      .filter(child => 
        isLineUpOrBottomSelection (child, startLine, endLine)
        //(child.destination.line < startLine || child.destination.line > endLine) // récuperer les lignes externes 
      
      || isSameLineAndInnerSelection (sameLigne, child, startLine, startOffset ,shiftStartLength)
        /*(sameLigne && child.destination.line == startLine && ( // mêmes lignes internes suprprimer les éléments internes
            (isListOrLineStyle(child.type) && 
              (startOffset >= 0)
            )
            || 
            (!isListOrLineStyle(child.type) && 
              (child.start < startOffset || child.start >= startOffset + shiftStartLength)
            
            )
          )  
        )*/
      || isNotSameLineAndInnerSelection  (sameLigne, child, startLine, startOffset, endLine, endOffset)
        /*!sameLigne && (
           (isListOrLineStyle(child.type) &&
              ( 
                child.destination.line == startLine  // Ne pas supprimer les lines styles ici ils seront supprimes plus bas
                //||  
                //child.destination.line == endLine/)  // Ne pas supprimer les lines styles ici ils seront supprimes plus bas
            )
          ||
          (!isListOrLineStyle(child.type) && 
            (
              ( child.destination.line == startLine && child.start < startOffset) // différentes lignes garder le syle de la premier ligne a gauche 
              || 
              (child.destination.line == endLine && child.end > endOffset) // différentes lignes garder le syle a droite de la derniere ligne 
            )
          )
        )*/
      )
      
      
      
      
      // décallage last line for sameLigne and not sameLigne
      
      if (colDecalage != 0)
        shiftToDecalage(updatedFormat.itemValue.childs, endLine, endOffset + 1, colDecalage)
      //end
      
      
      
      if (rowDecalage > 0)
        updatedFormat.itemValue.childs.map(child => {
        
        if (child.destination.line >= endLine) {
          child.source.line = child.source.line - rowDecalage
          child.destination.line = child.destination.line - rowDecalage
        } 
      })
      
      
      
      let newStartOffset = startOffset  
      
     /* let newAnchorNode = getChildByLineAndPositionIfDeleteReturnPrevious(startLine, newStartOffset)
      newStartOffset = newAnchorNode.textContent.length*/

      const detail = getChildByLineAndPositionIfDeleteReturnPrevious(startLine, newStartOffset)
      
      let newAnchorNode = detail.child
      newStartOffset = detail.position

       
      setCurrentRange(newAnchorNode,newStartOffset,newAnchorNode,newStartOffset)
      //curentRanges.nChar["previous"] = event.target.textContent.length
      
      setUpdatedFormat(updatedFormat,updatedFormat.itemValue.childs,curentRanges,content.scrollTop)
      
  }  

  const getFromPreviousStyles = (ranges, styles, shiftWhenStartOffsetEqualToEndOffset = 0) => {
    
    //let styles = getCurrentStyle(ranges, shiftWhenStartOffsetEqualToEndOffset)
    
    return format.isArobasePressed ? {childs:[], selectedsIds:[]} : 
    {childs:getNewValues(ranges, styles.filter(style => !isListOrLineStyle([style]) && style != variableStyleId)
      , shiftWhenStartOffsetEqualToEndOffset), selectedsIds:styles}
  }  

  const isLinkInSelectedIds = () => {
    return format.itemValue.selectedsIds.filter(id => getTypeId(id) == linkId).length > 0
  } 
  
  const saveNewInput= (content, updatedFormat, shiftDetail = undefined) => {
   
      
      setCurrentSelection(true);

      
      
      //var lengthInput = 1
      var previousChilds = [];
      var ranges = null
      if (content.childNodes[0].innerHTML){
        var selectionValue = buildSelection()
        setRange(selectionValue)
        ranges = curentRanges
        
        if(currentSelection.isLinkLastPosition){
          ranges["isLinkLastPosition"] = currentSelection.isLinkLastPosition
          ranges["previousSelection"] = currentSelection.previousSelection
          updatedFormat.itemValue.selectedsIds = updatedFormat.itemValue.selectedsIds.filter(id => !(getTypeId(id) == linkId))
        }

       
        
       
        previousChilds = getFromPreviousStyles(ranges, updatedFormat.itemValue.selectedsIds, -1)
        
      }
      else {
        ranges = getIntialRange()  
      }

      if(shiftDetail) {
        shiftToBottomByLine(updatedFormat.itemValue.childs, ranges.start.line, shiftDetail.nLine)
        shiftLineFromStartOffSetToBottom(updatedFormat.itemValue.childs, ranges.start.line , shiftDetail.startOffset, shiftDetail.nLine)
        shiftToDecalage(updatedFormat.itemValue.childs, ranges.end.line + shiftDetail.nLine, shiftDetail.startOffset, shiftDetail.endShift)      
      }
      else {
        if(!currentSelection.isLinkLastPosition)
          shiftToDecalage(updatedFormat.itemValue.childs,ranges.start.line,  ranges.startOffset)
        updatedFormat.itemValue.childs = [...updatedFormat.itemValue.childs, ...previousChilds.childs]
      }

      
      setUpdatedFormat(updatedFormat,updatedFormat.itemValue.childs,ranges,content.scrollTop) 
  }

  const getPreviousLineWithValue = (n) => {
    let line = getDivLineByLine(n)
    if (line.div == null || line.div.textContent.length > 0)
      return line
    return getPreviousLineWithValue(n-1)
  }

  /*
  const getCurrentStyle = (ranges, shiftPositionFromCurrent = 0) => {
    var selectedsIds = []

  
    let sameLigne = ranges.start.line == ranges.end.line
    let samePosition = ranges.startOffset == ranges.endOffset
    let firstCharOfLine = ranges.startOffset <= 1
    let previousDiv = undefined
    let lastCharPositionForPreviousDiv = undefined
    if (firstCharOfLine) {
      previousDiv = getPreviousLineWithValue(ranges.start.line-1)

      if (previousDiv.div != null)
        lastCharPositionForPreviousDiv = previousDiv.div.textContent.length
    }
    let currentChilds = format.itemValue.childs.filter(child => !textAlignTypes.includes(child.type[0]) && !listStyleTypes.includes(child.type[0]))
    // group type by line and start 
    currentChilds = getArrangedBalise(getBalise(JSON.parse(JSON.stringify(currentChilds))))
      
    if (sameLigne && samePosition)
      currentChilds = currentChilds.filter(child =>
        (  
          (!firstCharOfLine && child.destination.line == ranges.start.line  && child.end == ranges.startOffset + shiftPositionFromCurrent ) 
          || 
          (firstCharOfLine && child.destination.line == previousDiv.line && child.end == lastCharPositionForPreviousDiv + shiftPositionFromCurrent)      
        )
      )

    if (sameLigne && !samePosition) //  meme ligne et differente position recupere le style dans la plage    
      currentChilds = currentChilds.filter(child => child.destination.line == ranges.start.line  
        && ranges.startOffset >= child.start && child.end >= ranges.endOffset
      )
    
    if (!sameLigne ) {
      currentChilds = currentChilds.filter(child => 
        (
          (child.destination.line == ranges.start.line && child.end >= ranges.startOffset)
          //|| (child.destination.line == ranges.end.line && child.end <= ranges.endOffset)
          //|| (child.destination.line > ranges.start.line && child.destination.line < ranges.end.line)
        )
      )
    }

    // selectionner tous les types 
    let types =[]
    currentChilds.map(child => {types = Array.from(new Set([...types, ...child.type ]))})
    
    //* selectionner tous les childs qui ont tous les types 
    let isChildsHasAllTypes = currentChilds
    .filter(child => !isAllValuesInFirstArrayAreInSecondArray(types, child.type) )
    .length == 0

    if (isChildsHasAllTypes)
      currentChilds.map(child => {
        selectedsIds = Array.from(new Set( [...selectedsIds, ...child.type]))
      })

    
    return selectedsIds
  }
   */

  const isListOrLineStyle = (type) => {
    return isListStyleType(type) || isLineStyleType(type)
  }
  
  const getSelectedIds=(ranges, childs = format.itemValue.childs) => {
    let sameLigne = ranges.start.line == ranges.end.line
    let samePosition = ranges.startOffset == ranges.endOffset
    
    if (sameLigne && samePosition) {
      let firstCharOfLine = ranges.startOffset < 1  //let firstCharOfLine = ranges.startOffset <= 1  
      let previousDiv = undefined
      let lastCharPositionForPreviousDiv = undefined
      if (firstCharOfLine) {
        previousDiv = getPreviousLineWithValue(ranges.start.line-1)

        if (previousDiv.div != null)
          lastCharPositionForPreviousDiv = previousDiv.div.textContent.length
      }

      return childs.filter(child =>
        (  (isListOrLineStyle(child.type) 
          && child.destination.line == ranges.start.line)
          ||
          (!firstCharOfLine && child.destination.line == ranges.start.line  && child.end == ranges.startOffset  ) 
          || 
          (firstCharOfLine && !isListOrLineStyle(child.type)
            && child.destination.line == previousDiv.line && child.end == lastCharPositionForPreviousDiv )      
        )).map(child => child.type).flat(Infinity)
      
      
    }
    
    let selectedsIds = childs.filter(child => {
      if (isListOrLineStyle(child.type))
        return child.destination.line == ranges.start.line
      else
        return child.destination.line == ranges.start.line && child.start == ranges.startOffset
    })
      .map(child => child.type).flat(Infinity)
    if (selectedsIds.length == 0) return selectedsIds
    
    selectedsIds = childs.filter(child => {
      if (isListOrLineStyle(child.type))
        return child.destination.line == ranges.end.line
      else
        return child.destination.line == ranges.end.line && child.end == ranges.endOffset
      }).map(child => child.type).flat(Infinity)

    if (selectedsIds.length == 0) return selectedsIds
    
    let i = ranges.start.line
    let isValid = true
       
    while (isValid && i <= ranges.end.line){
     
      let startPosition = i == ranges.start.line ? ranges.startOffset : 0
      let endPosition = i == ranges.end.line ? ranges.endOffset : getDivLineByLine(i).div.textContent.length      
      
      let j = startPosition 
      while (isValid && j < endPosition){
        let types = childs.filter(child => {
          if (isListOrLineStyle(child.type))
            return child.destination.line == i
          else
            return child.destination.line == i && child.start == j
          })
        .map(child => child.type).flat(Infinity)

        isValid = isSameArray(selectedsIds, types)
        j = j + 1
      }
      i = i + 1
    }
    selectedsIds = selectedsIds.filter(id => id != variableStyleId)
    return isValid ? Array.from(new Set(selectedsIds)) : []
  }

  const isSameArray = (firstArray, secondArray) => {
    
    return firstArray.filter(first => !secondArray.includes(first)).length == 0 && 
    secondArray.filter(second => !firstArray.includes(second)).length == 0
  }
  /*
  const isAllValuesInFirstArrayAreInSecondArray = (firstArray, secondArray) => {
    return firstArray.filter(value => !secondArray.includes(value)).length == 0
  }

  const isActiveOnAllPartInMultiLigne = (childs, ranges) => {
    let hasMiddle = (ranges.end.line - ranges.start.line) > 1
    let isInMiddle = hasMiddle && childs.filter(child =>
       child.destination.line > ranges.start.line  && child.destination.line < ranges.end.line 
    ).length > 0

    let isInStartLine = childs.filter(child =>
      child.destination.line == ranges.start.line  && child.start >= ranges.startOffset
    ).length > 0

    let isInEndLine = childs.filter(child =>
      child.destination.line == ranges.end.line  && child.end <= ranges.endOffset
    ).length > 0
    
    return (isInStartLine || isInMiddle || isInEndLine)
  
  }
  */
  const isActiveOnAnyPartInMultiLigne = (childs, ranges) => {
    let hasMiddle = (ranges.end.line - ranges.start.line) > 1
    let isInMiddle = hasMiddle && childs.filter(child =>
       child.destination.line > ranges.start.line  && child.destination.line < ranges.end.line).length > 0

    
    let isInStartLine = childs.filter(child =>
      child.destination.line == ranges.start.line  && child.end > ranges.startOffset
    ).length > 0
    
    
    let isInEndLine = childs.filter(child =>
      child.destination.line == ranges.end.line  && child.end <= ranges.endOffset
    ).length > 0
    
    return (isInMiddle || isInStartLine || isInEndLine)
  
  }

  const getPreviousLineStyle = (start, line) => {
    var selectedsIds = []
    format.itemValue.childs.filter(child =>
     /* (child.destination.line == line && child.end == start ) 
      ||*/
      (child.destination.line == line && listStyleTypes.includes(child.type[0]) )
    )
    .map(child => {
      selectedsIds =  Array.from(new Set( [...selectedsIds, ...child.type]))
    })

    return format.itemValue.selectedsIds //selectedsIds
  }

  const getNewValues = (ranges, newTypes, shiftWhenStartOffsetEqualToEndOffset = 0) => {
    
    var content = getAllContent()
    let lines = getAllLines(content)
    var rects = ranges.rects;
    var newValues = []
    
    newTypes.map(type =>
      rects.map(rect => {   
        
        let div = lines[rect.line]        
        let startOffset = ranges.startOffset + shiftWhenStartOffsetEqualToEndOffset
        let endOffset = ranges.endOffset 
        
        if ( rect.line != ranges.start.line && rect.line != ranges.end.line) {
          startOffset = 0
          endOffset = div.textContent.length
        }
        else if (rect.line == ranges.start.line && rect.line != ranges.end.line) 
          endOffset = div.textContent.length 
        else if (rect.line != ranges.start.line && rect.line == ranges.end.line) 
          startOffset = 0
     
        var sourceTop = rect.top
        var destinationTop = isListStyleType([type])? rects[0].top:rect.top 
        let line = rect.line
        var source = {id: 0, top:sourceTop, line:line}
        let newRanges = []
        if (type == breakLineId) {
          newValues = [...newValues, ...getRanges(deleteId, source, {id: 0,line:line, top:destinationTop}, startOffset, endOffset)]
          destinationTop = rect.top + ranges.addLine 
          line = line + 1
          newRanges = getRanges(type, source, {id: 0,line:line, top:destinationTop}, startOffset, endOffset)
          /*let actualLine = format.itemValue.childs.filter(value => 
          value.destination.line == ranges.start.line && value.start >= ranges.startOffset)*/
          newRanges.map(range => {
            /*let types = actualLine.filter(item => item.start == range.start).map(item => item.type).flat(Infinity)
            if (types) {*/
              range["newStart"] = range.start - startOffset  
              range["newEnd"] = range.end - startOffset
              range["newLine"] = line
              /*range.type = [...range.type, ...types]
            
            }*/
          })    

          newRanges =[...newRanges, ...getShiftStyleOfNewLine(newRanges, ranges.start.line, ranges.startOffset)]
        } 
        else 
          newRanges = getRanges(type, source, {id: 0,line:line, top:destinationTop}, startOffset, endOffset)
      
        
        newValues = [...newValues, ...newRanges]

      })
    )

    
    return newValues
  }
  
  const isDeleteCode = () => { 
   
    return keyCode == deletekeyCode || keyCode == backspacekeyCode || keyCode == xkeyCode
  }
  
  const saveInput = (shiftDetail = undefined, closeDialog = false, event=undefined) => {
      var updatedFormat = JSON.parse(JSON.stringify(format));
     /* if (!currentSelection.isCollapsed)  {
        keyCode = deletekeyCode
        setCurrentSelection()
        buildSelectionAndSetRange()
      } */
      
        if (curentRanges == null) curentRanges = format.itemValue.ranges
      
        var content = getAllContent()
        updatedFormat.itemValue.currentLine["line"] = undefined
        if (closeDialog) updatedFormat.isArobasePressed = false
        if (content.textContent == "") {    
          updatedFormat.itemValue.forceRender = !format.itemValue.forceRender;
          updatedFormat.itemValue.content = getEmptyContent();    
          updatedFormat.itemValue.currentValue = ""   
          updatedFormat.itemValue.scroll["top"] = content.scrollTop
          updatedFormat.itemValue.ranges = {currentId:initialId, keyCode:keyCode}
          updatedFormat.itemValue.childs = []
        }
        else {
          
          if (isDeleteCode() && curentRanges) 
            deleteIfNeeded(updatedFormat, event)
          else {
            
            saveNewInput(content, updatedFormat, shiftDetail)
          }
        }
     
      setFormatWithHistorical(updatedFormat)
  }
  
  const setFormatWithHistorical = (updatedFormat) => {
    updatedFormat.isCtrlPressed = false;
    updatedFormat.isPreviousEnabled = true;
    if (updatedFormat.initialValue) updatedFormat["initialValue"] = undefined;
    updatedFormat.itemValue.ranges["callBackDetails"] = callBackDetails
    
    setHistorical(updatedFormat)
    setFormat(updatedFormat)
    
  }

  const onSaveEdition = (updatedFormat) => {
    if (props.onSaveEdition && updatedFormat.historical.itemValues.length>0) {
      updatedFormat.itemValue["textContent"] = document.getElementById(ContentId).textContent
      updatedFormat.itemValue["innerHTML"] = document.getElementById(ContentId).innerHTML
      let copyUpdatedFormat = {...updatedFormat}
     
      copyUpdatedFormat.itemValue =  {...copyUpdatedFormat.itemValue, content:undefined}
      copyUpdatedFormat.historical = {position: 0, itemValues:[copyUpdatedFormat.itemValue, copyUpdatedFormat.itemValue]}
      props.onSaveEdition(copyUpdatedFormat)
    }
  }
  
  const setUpdatedFormat = (updatedFormat,styles, ranges,scrollTop ) => {
    
    styles = RemoveStyle(styles)

    //if (!keyCode)     //sometimes when quickly tip or maintain key pressed onkeydown is not fire 
    //ranges.nChar["previous"] = format.itemValue.ranges.nChar.previous
    refreshLineId(styles)
    
    var current = getContent(styles);
    
    ranges["currentId"] = current.currentId
    updatedFormat.itemValue.childs = current.childs
    updatedFormat.itemValue.forceRender = !format.itemValue.forceRender;
    updatedFormat.itemValue.content = current.content;    
    updatedFormat.itemValue.currentValue = current.currentContentValue    
    updatedFormat.itemValue.scroll["top"] = scrollTop
    updatedFormat.itemValue.ranges = ranges
    
    
    
  }
 
  const isLineStyleType = (types) => {
    return lineStyleTypes.filter(x => types.includes(x)).length > 0
  }

  const isListStyleType = (types) => {
    return listStyleTypes.filter(x => types.includes(x)).length > 0
  }

  const extractStyleFromFormat = (formats, lineStyles) => {
    formats.map(format => {
      format.type.map( type => {
        if (lineStyleTypes.includes(type)) {
          lineStyles.push(type)
          format.type = format.type.filter(item => item != type)
        }
      })
    })
  }
  
  const extractFontStyle = (types, foundFontTypes) => {
    
    types.map(type => {
      let extractTypeIds = extractIds(type)
      if (fontTypes.includes(extractTypeIds.type)) {
        foundFontTypes.push({type:extractTypeIds.type, font:extractTypeIds.font})
        types = types.filter(item => item != type)
      }
    })  
    return types
  }

  const extractListStyle = (formats, listStyles) => {
    formats.map(format => {
      format.type.map( type => {
        if (listStyleTypes.includes(type)) {
          listStyles.push(JSON.parse(JSON.stringify(format)))
          format.type = format.type.filter(item => item != type)
        }
      })
    })
  }

  const getLineContent = (formats, div, contentDivLine, id) => {
    
    var content = div.textContent  
    var endIndex = formats[0] ? formats[0].start : content.length;
    var currentContentValue = null;
    var formatedValue = null;
    var formated =null;
    var currentContentId = id 
    if (content.substring(0, endIndex) != "" ) {   
      currentContentValue = content.substring(0, endIndex);
      formatedValue = getFormatedValue([-1], currentContentValue, id);
      formated = formatedValue.formated;
      currentContentId = formatedValue.currentId;
      id = formatedValue.id; 
    }
    var currentLine = null
    var prevIndex = endIndex  
    var lineStyles = []
    
    extractStyleFromFormat(formats, lineStyles)

    var style = {whiteSpace: "pre", minHeight:"21px" }
    if (lineStyles.length > 0) { 
      getFormatedValue(lineStyles, style, 0);
    }
    
    let linebalises = formats.filter(format => format.type.length > 0)
    
    linebalises.map(item => {     
      let sourceContent = contentDivLine.filter(divLine => divLine.div.id == item.source.id)[0].div.textContent

      if (item.start != prevIndex && sourceContent.substring(prevIndex, item.start) != "" ) {     
        formatedValue = getFormatedValue([-1], sourceContent.substring(prevIndex, item.start), id);
        id = formatedValue.id;
        currentLine = formatedValue.formated;
        formated = <React.Fragment>{formated}{currentLine}</React.Fragment>
        prevIndex = item.start
      }
      currentContentValue = sourceContent.substring(item.start, item.end); 
      formatedValue = getFormatedValue(item.type, currentContentValue, id);
      id = formatedValue.id;
      currentLine = formatedValue.formated; 
      currentContentId = formatedValue.currentId;  
      prevIndex =item.end
      formated = <React.Fragment>{formated}{currentLine}</React.Fragment>;
    })
   
    if (content.slice(prevIndex).length != 0) {
      currentContentValue = content.slice(prevIndex);
      formatedValue = getFormatedValue([-1], currentContentValue, id);
      id = formatedValue.id;
      currentLine = formatedValue.formated;
      currentContentId = formatedValue.currentId;     
      formated = <React.Fragment>{formated}{currentLine}</React.Fragment>;
    }
    id = id + 1

    
    formated = <React.Fragment><div id={id} style={style}>{formated}</div></React.Fragment>
    
    return { currentLine: formated, currentContentId: currentContentId, currentContentValue: currentContentValue, id: id };
  }

  const getNewLine = (value, id) => {
    return <div id={id} style={{  whiteSpace: "pre", minHeight:"21px" }}>
      {value}
    </div>
  }

  const groupTypeByLineAndPosition = (newValues) => {

     /* group type by line and start */
     newValues = newValues.reduce((groups, item) => {
      var found = false;
      groups.filter(group => group.destination.line == item.destination.line && group.start == item.start).map(group => {
        found = true;
        group.type = Array.from(new Set([...group.type, ...item.type]))
      });
      if (!found) groups.push(item)
      return groups;
    }, [])
    return newValues
  }
  const getArrangedBalise = (newValues) => {
     
   
    /* group type by line and start 
    newValues = newValues.reduce((groups, item) => {
      var found = false;
      groups.filter(group => group.destination.line == item.destination.line && group.start == item.start).map(group => {
        found = true;
        group.type = Array.from(new Set([...group.type, ...item.type]))
      });
      if (!found) groups.push(item)
      return groups;
    }, [])
    */

    newValues = groupTypeByLineAndPosition(newValues);
  
    /* sort by top and start */
    newValues = newValues.sort((a, b) => (a.destination.line > b.destination.line) ? 1 : 
      (a.destination.line == b.destination.line) ? ((a.start > b.start) ? 1 : -1) : -1);
    
    /* group same continue style by start */
    var newItem = [];
    if (newValues[0]) {
      var previous = { start: 0, end: 0 };
      newValues.reduce((prev, next) => {

        if (isContinueFormat(prev, next) && isTypeEqual(prev, next)) {

          previous.end = previous.end + 1;
          newItem.filter(item => item.start == previous.start && item.destination.line == previous.destination.line)
            .map(item => item.end = previous.end)
        }
        else {
          previous = JSON.parse(JSON.stringify(next));
          newItem.push(previous);
        }
        return next;
      }, [])
    }
    
    return newItem
  }

  const getArrangedLineStyle = (newValues) => {
      
    /* group type by line */
    newValues = newValues.reduce((groups, item) => {
      var found = false;
      groups.filter(group => group.destination.line == item.destination.line).map(group => {
        found = true;
        group.type = Array.from(new Set([...group.type, ...item.type]))
      });
      if (!found) groups.push(item)
      return groups;
    }, [])

    /* sort by top */
    newValues = newValues.sort((a, b) => (a.destination.line > b.destination.line) ? 1 :  -1);
     
    return newValues
  }

  const getArrangedList = (newValues) => {
    
    
    /* group type by line */
    newValues = newValues.reduce((groups, item) => {
      var found = false;
      groups.filter(group => group.destination.line == item.destination.line).map(group => {
        found = true;
        group.type = Array.from(new Set([...group.type, ...item.type]))
        group.source = Array.from(new Set([...group.source, {id:item.source.id, top:item.source.top, line:item.source.line}]))
      });
      if (!found) {
        
        item.source = [{id:item.source.id, top:item.source.top, line:item.source.line}]
        groups.push(item)
      }
      return groups;
    }, [])

    
    
    
    /* sort by top and start */
    newValues = newValues.sort((a, b) => (a.destination.line > b.destination.line) ? 1 : -1);
    
    
    return newValues
  }

  const getBalise = (childs) => {
    return childs.filter(child => !lineStyleTypes.includes(child.type[0]) && !listStyleTypes.includes(child.type[0]))
  }
  const getNewStyle = (childs) => {
   
    
   var balises = getBalise(childs) //.filter(child => !lineStyleTypes.includes(child.type[0]) && !listStyleTypes.includes(child.type[0]))
   var lineStyles = childs.filter(child => lineStyleTypes.includes(child.type[0]))
   var listStyles = childs.filter(child => listStyleTypes.includes(child.type[0]))
   balises = getArrangedBalise(balises)
   lineStyles = getArrangedLineStyle(lineStyles)
   listStyles = getArrangedList(listStyles)
   
      
   return [...balises, ...lineStyles, ...listStyles]
  }

  const getInnerHTML = (divs, newItem, innerHTML) => {

    var contentDivLine = Array.from(divs).map(divLine =>  
      {return { div:divLine, top: getTopValue(divLine.getBoundingClientRect().top) }})
    var formated = null
    var formatedValue = null
    var id = getInitialId()
    var currentContentId = id;
    var currentContentValue = "";
    var currentLine = null
        
    var groupLineStyles = []
    extractListStyle(newItem, groupLineStyles)
    let lineStyles = newItem.filter(newItem => newItem.type.length > 0)
    
    var actualGroup = undefined;
    let prevType = undefined
    var actualGroupContent = undefined;
    
    contentDivLine.map(divLine => {
      const div = divLine.div
      /*let lineStyle = lineStyles.filter(item => isInCurrentLine(div, item.destination.top))*/
      let lineStyle = lineStyles.filter(item => item.destination.id == div.id)
      
      actualGroup = groupLineStyles.filter(group => group.source.filter(source => source.id == div.id).length > 0)[0]
      currentLine = null;
      
      if (!actualGroup && actualGroupContent) {
        id = id + 1
        formatedValue = getFormatedValue(prevType, actualGroupContent, id);
        formated = <React.Fragment>{formated}{formatedValue.formated}</React.Fragment>
        actualGroupContent = undefined;
      }

      if (lineStyle.length > 0) {    
        
        let line = getLineContent(lineStyle, div, contentDivLine, id)       
        currentContentId = line.currentContentId      
        currentContentValue = line.currentContentValue
        currentLine = line.currentLine
        id = line.id      
      }
      else {
        currentContentValue = div.textContent;
        formatedValue = getFormatedValue([-1], currentContentValue, id);
        id = formatedValue.id;
        currentContentId = formatedValue.currentId;
        id = id + 1    
        currentLine = <div id={id} style={{  whiteSpace: "pre", minHeight:"21px" }}>{formatedValue.formated}</div>;
      }
         
      if (!actualGroup){
        formated = <React.Fragment>{formated}{currentLine}</React.Fragment>
      }
      else {
        id = id + 1;
        formatedValue = getFormatedValue([liId], currentLine, id)
        prevType = actualGroup.type
        actualGroupContent = <React.Fragment>{actualGroupContent}{formatedValue.formated}</React.Fragment>
      }
    })

    if (actualGroupContent) {
      id = id + 1

      formatedValue = getFormatedValue(actualGroup.type, actualGroupContent, id)
      formated = <React.Fragment>{formated}{formatedValue.formated}</React.Fragment>
      
    }
   
    innerHTML["formated"] = formated
    innerHTML["currentContentValue"] = currentContentValue
    innerHTML["currentContentId"] = currentContentId
    
  }

 
  const getContent = (childs, itemSelected=undefined) => {
    
    let type = itemSelected ? itemSelected.type : undefined
    var originalChild = JSON.parse(JSON.stringify(childs));
    var newItem = getNewStyle(JSON.parse(JSON.stringify(childs)))

    
    var content = getAllContent()
    var formated = null
    var formatedValue = null
    //var id = 0
    
    var id = getInitialId()
    
    
    var currentContentId = id;
    var currentContentValue = "";
    var currentLine = null
      
    var divs = getAllLines(content)
   
    if (divs.length == 0){
      currentContentValue = content.textContent;
      formatedValue = getFormatedValue([-1], currentContentValue, id);
      id = formatedValue.id;
      currentContentId = formatedValue.currentId;
      id = id + 1
      currentLine = <div id={id} style={{ whiteSpace: "pre", minHeight:"21px" }}>{formatedValue.formated}</div>;
      formated = <React.Fragment>{currentLine}</React.Fragment>
      
    }
    else
    {
      var innerHTML = {}
      
      getInnerHTML(divs, newItem, innerHTML)
      currentContentId = innerHTML.currentContentId;
      formated = innerHTML.formated;
      currentContentValue = innerHTML.currentContentValue;
      //if(typesToRemoveAfterFormated.includes(type)) originalChild = RemoveStyle(originalChild )
      
     
      originalChild = RemoveStyle(originalChild )
      
      
      
    }
   
    return { content: formated, currentId: currentContentId, currentContentValue: currentContentValue, childs:originalChild };
  }


  const RemoveStyle = (originalChild) => {
    originalChild.map(child => 
      child.type = child.type.filter(type =>  !typesToRemoveAfterFormated.includes(type))
    )
    return originalChild.filter(child => child.type.length != 0)
  }

  const isContinueFormat = (prev, next) => {
   
    return prev.destination && next.destination.line == prev.destination.line && next.start == prev.start + 1
  }

  const isTypeEqual = (prev, next) => {
    var isTypeEqual = prev.type.filter(item => !next.type.includes(item)).length == 0
      && next.type.filter(item => !prev.type.includes(item)).length == 0;

    return isTypeEqual;
  }

  const shiftToDecalage = (childs, line, startOffset, decalage = 1) => {
    
    childs.filter(value => value.destination.line == line 
      && value.start  >= startOffset - 1)
    .map(range => {
        range.start = range.start + decalage
        range.end = range.end + decalage
    })   
  }

  const shiftLineFromStartOffSetToBottom = (childs, line, startOffset, nLine = 1) => {
    childs.filter(value => value.destination.line == line 
      && value.start  >= startOffset - 1)
    .map(child => {
        child.destination.line = child.destination.line + nLine
        child.source.line = child.source.line + nLine
    })   
  }

  const shiftToBottomByLine = (childs, line , nLine = 1) => {

    childs.filter(child => child.destination.line > line).map(child => {
      child.destination.line = child.destination.line + nLine
      child.source.line = child.source.line + nLine
    })
  }

  const getShiftStyleOfNewLine = (newRanges, line, startOffset) => {
    
    var newValues = []
    let actualLine = format.itemValue.childs.filter(value => 
    value.destination.line == line && value.start >= startOffset)
    newRanges.map(range => {
      let types = actualLine.filter(item => item.start == range.start).map(item => item.type).flat(Infinity)
      types.map(type=> {
        let newValue = JSON.parse(JSON.stringify(range))
        newValue.type = [type]
        newValues = [...newValues, newValue]
      })
    })
    return newValues
  }

  const isChildOfSameGroupAndInThisRange = (child, ranges, type ) => {
    
    
    let isOfThisGroupType = (textAlignTypes.includes(type) && textAlignTypes.includes(child.type[0])) 
    ||  listStyleTypes.includes(type) && listStyleTypes.includes(child.type[0])
   
    return ( isOfThisGroupType  && ranges.start.line <= child.destination.line 
      && child.destination.line <= ranges.end.line)
      
    
  }
  
  const isChildOfThisTypeAndInThisRange = (child, ranges, type ) => {
    let sameLigne = ranges.start.line == ranges.end.line
    let isLineStyle = textAlignTypes.includes(type) || listStyleTypes.includes(type)
    
    let isOfThisType = (fontTypes.includes(extractIds(child.type).type) && isSameFontType(child.type, type)) || child.type.includes(type)
    
    
    return ( isOfThisType    
      && ((isLineStyle && ranges.start.line <= child.destination.line && child.destination.line <= ranges.end.line)
          || 
          (!isLineStyle 
            &&(
                (sameLigne && ranges.start.line == child.destination.line
                  && ranges.startOffset < child.end && child.end <= ranges.endOffset)
                ||
                (!sameLigne && isActiveOnAnyPartInMultiLigne([child], ranges))
              )
          ) 
        )
      )  
    
  }

 
    
  /*const removeSelectStyle = (childs, ranges, type ) => {
    
    childs = childs.filter(child => !isChildOfThisTypeAndInThisRange(child,ranges,type))
     
    return childs
  }*/

  const removeSelectStyle = (childs, ranges, type, isLinkType ) => {
    
    if (isListOrLineStyle([type])){
      childs = childs.filter(child => !isChildOfSameGroupAndInThisRange(child,ranges,type))
    }
    else if (isLinkType)
      childs = childs.filter(child => child.type[0] != type)
    else
      childs = childs.filter(child => !isChildOfThisTypeAndInThisRange(child,ranges,type))
     
    return childs
  }

  const isSameFontType = (oldType, newType)=> {
    let oldFont = extractIds(oldType).font
    let newFont = extractIds(newType).font
    return oldFont && newFont && oldFont.fontId == newFont.fontId
  }
 
  /*
  const addChildsAndRemovePreviousStylesThatShoulBeOnePerGroup = (childs, type, rangeData, isFontType) => {
    
    let lines = childs.filter(child => child.destination.line >= rangeData.start.line 
      && rangeData.end.line <= child.destination.line)
    .map(newValue => newValue.destination.line)
    
    if (isFontType){  
      childs = childs.filter(child => !isChildOfThisTypeAndInThisRange(child,rangeData,type))
    }
    else if (textAlignTypes.includes(type)){
      childs = childs.filter(child => !isChildOfSameGroupAndInThisRange(child,rangeData,type))
    }else if (listStyleTypes.includes(type)){
      childs = childs.filter(child => !isChildOfSameGroupAndInThisRange(child,rangeData,type))
    }

    
    return childs
  }

  
  const getNewLineStyle = (newValues, startOffset, previousLine) => {
    let newLineStyle = getPreviousLineStyle(startOffset, previousLine)
    let newLinePosition = previousLine + 1
    let newLineValue = newValues.filter(newValue => newValue.destination.line == newLinePosition)[0]
    
    var newLineStyles = []
    newLineStyle.map(newType => {
      
      let newValue = JSON.parse(JSON.stringify(newLineValue))
      newValue.source = newValue.destination
      newValue.type = [newType]
      newLineStyles = [...newLineStyles, newValue]
    })
    return newLineStyles
  }
  */
  const getNewLineStyle = (newValues, startOffset, previousLine) => {
    let newLineStyle = getPreviousLineStyle(startOffset, previousLine)
    let newLinePosition = previousLine + 1
    let newLineValue = newValues.filter(newValue => newValue.destination.line == newLinePosition)[0]
    
    
    var newLineStyles = []
    if (newLineValue)
      newLineStyle.map(newType => {
      
        let newValue = JSON.parse(JSON.stringify(newLineValue))
        newValue.source = newValue.destination
        newValue.type = [newType]
        newLineStyles = [...newLineStyles, newValue]
      
      })
    
    return newLineStyles
  }


  const isAlreadySelectedTypeOrGroupType = (currentFormat, type, isFontType, isLinkType) => {
    
    if (isFontType) 
      return currentFormat.itemValue.selectedsIds.filter(item => isSameFontType(item, type)).length > 0
    
    else if (isLinkType) 
      return currentFormat.itemValue.selectedsIds.filter(item => extractUrlIds(item).type == linkId ).length > 0
    else 
      return currentFormat.itemValue.selectedsIds.includes(type)

  }

  
  //const onClickItem = (itemSelected, rangeData = curentRanges) => {
  const onClickItem = (itemSelected, rangeData = currentRangeValue) => {
    
    if(itemSelected.type == undoId)
      setPrevious()
    else if (itemSelected.type == redoId)
      setNext()
    else
      onClickStyleItem (itemSelected, rangeData)
  }

  const onClickStyleItem = (itemSelected, rangeData = curentRanges, checkedDetail = undefined) => {
    
    if (!rangeData || (rangeData.isCollapsed && !isListOrLineStyle([itemSelected.type]))) return
    var ranges = rangeData;
    var updatedFormat = JSON.parse(JSON.stringify(format));
    var parameters = getParameters(updatedFormat, itemSelected)
    updatedFormat.isArobasePressed = false
    if (itemSelected.operation == "DEL" && parameters.isSelect) return
    
    var states = getNewFormat(updatedFormat, itemSelected, rangeData, ranges, parameters);
    updatedFormat = states.updatedFormat
    
    if (parameters.isLinkType && !parameters.isSelect ) {
      switch (itemSelected.operation) {
        case "ADD":
          parameters = getParameters(updatedFormat, itemSelected)
          states = getNewFormat(updatedFormat, itemSelected, rangeData, ranges, parameters)
          updatedFormat = states.updatedFormat
          break;
      }  
    }
    if (checkedDetail ) {
      updatedFormat.itemValue["checkedDetail"] = checkedDetail
    }
    
    setFormatWithHistorical(updatedFormat);
  }

  const getTypeId = (type) => {
    return parseInt((type + "").slice(0,2))
  }

  const getParameters = (currentFormat, itemSelected) => {
    let type = itemSelected.type
    
    let typeId = getTypeId(type)
    
    let isFontType = fontTypes.includes(typeId)
    let isLineStyle = lineStyleTypes.includes(type)
    let isListStyle = listStyleTypes.includes(type)
    let isLinkType = typeId == linkId

    let isSelect = !isAlreadySelectedTypeOrGroupType(currentFormat, type, isFontType, isLinkType)
    let isFontAndCtrlASelected = isFontType && isCtrlAPressed

    return {type:type, typeId:typeId, isFontType:isFontType, isLineStyle:isLineStyle, 
      isListStyle:isListStyle, isLinkType:isLinkType, isSelect:isSelect,
      isFontAndCtrlASelected:isFontAndCtrlASelected
     }
  }
 
  const getNewFormat = (updatedFormat, itemSelected, rangeData, ranges, states) => {
    
    if (!rangeData) return
    var ranges = rangeData;

    let type = states.type
    
    let typeId = states.typeId
    
    let isFontType = states.isFontType
    let isLineStyle = states.isLineStyle
    let isListStyle = states.isListStyle
    let isLinkType = states.isLinkType

    let isSelect = states.isSelect
    let isFontAndCtrlASelected = states.isFontAndCtrlASelected
       
    var rects = ranges.rects;
    /* sort by line left */
    rects = rects.sort((a, b) => (a.line > b.line) ? 1 : 
      (a.line == b.line) ? ((a.left > b.left) ? 1 : -1) : -1);
    
     /* group by top */
    rects = rects.reduce((groups, item) => {
      var found = false;
      
      groups.filter(group => group.line == item.line).map(group => {
        found = true;
        group.left = Array.from(new Set([...group.left, item.left]))
      });
      if (!found) groups.push({top:item.top, line:item.line ,left:[item.left]})
      return groups;
    }, [])

    
    
    
    var content = getAllContent()
    //let lines = getAllLines(content)
    let isEmptyContent = content.textContent == ""
    
    if (content != null) {
      var newValues = []
     
      if (isSelect && !isFontAndCtrlASelected)
        newValues = getNewValues(ranges, [type])
      
      
      if(type == breakLineId) {
        shiftToBottomByLine(updatedFormat.itemValue.childs, rangeData.start.line)
        newValues = [...newValues, ...getNewLineStyle(newValues, rangeData.startOffset, rangeData.start.line)]
      }
      
      
      if (isSelect || isFontAndCtrlASelected) {

        if (isLinkType) {      
          
          newHref = itemSelected.value
          let extractUrl = extractUrlIds(type)
          updatedFormat.itemValue.urls.data.push({id:extractUrl.id, item:newHref })
          updatedFormat.itemValue.urls.nextId = extractUrl.id + 1
          
        }

        if(isListStyle || isLineStyle || isFontAndCtrlASelected)
          updatedFormat.itemValue.childs = removeSelectStyle(updatedFormat.itemValue.childs,ranges,type)
          
        if (isListStyle)
          updatedFormat.itemValue.selectedsIds = updatedFormat.itemValue.selectedsIds.filter(item => !listStyleTypes.includes(item))
        if (isLineStyle)
          updatedFormat.itemValue.selectedsIds = updatedFormat.itemValue.selectedsIds.filter(item => !textAlignTypes.includes(item))

        if(!typesToRemoveAfterFormated.includes(type))
          updatedFormat.itemValue.selectedsIds = [...updatedFormat.itemValue.selectedsIds, type] 
      }
      else {
       
        if (isLinkType) {
          type = updatedFormat.itemValue.selectedsIds.filter(item => extractUrlIds(item).type == linkId )[0]
          let extractUrl = extractUrlIds(type)
          updatedFormat.itemValue.urls.data = updatedFormat.itemValue.urls.data.filter(url => url.id != extractUrl.id)
         
        } 
      
        updatedFormat.itemValue.childs = removeSelectStyle(updatedFormat.itemValue.childs,ranges,type, isLinkType)
        updatedFormat.itemValue.selectedsIds = updatedFormat.itemValue.selectedsIds.filter(item => item != type)
      }

      newValues = [...updatedFormat.itemValue.childs, ...newValues]

      refreshLineId(newValues)
      
      var current = getContent(newValues);    
      
      if(type == breakLineId) {
        updatedFormat.itemValue.ranges.startOffset = current.currentContentValue.length
        updatedFormat.itemValue.ranges.endOffset = current.currentContentValue.length
        updatedFormat.itemValue.ranges.start = undefined
        updatedFormat.itemValue.ranges.end = undefined 
        
        current.childs.map( child => {
          if (child.newStart != undefined ) {
            child.start = child.newStart
            child.end = child.newEnd
            child.source.line = child.newLine
            child.destination.line = child.newLine
            delete child.newStart
            delete child.newEnd
            delete child.newLine 
          }
        })
        
        
      }
      else
      {
        
        if (fontTypes.includes(typeId)) {

          updatedFormat.itemValue.font[itemSelected.wording].value = itemSelected.item.item
          if (isCtrlAPressed || isEmptyContent) {
            updatedFormat.itemValue.font[itemSelected.wording].default = itemSelected.item.item

          }
        }
        updatedFormat.itemValue.ranges.startOffset =rangeData.startOffset
        updatedFormat.itemValue.ranges.endOffset=rangeData.endOffset
        updatedFormat.itemValue.ranges["start"] = rangeData.start
        updatedFormat.itemValue.ranges["end"] = rangeData.end 
      }
      
      /*
      if (isSelect)
        updatedFormat.itemValue.selectedsIds = [...updatedFormat.itemValue.selectedsIds, type]
      else
        updatedFormat.itemValue.selectedsIds = updatedFormat.itemValue.selectedsIds.filter(item => item != type)
      */
      updatedFormat.itemValue.childs = current.childs
      updatedFormat.itemValue.ranges.currentId = current.currentId
      updatedFormat.itemValue.currentLine["line"] = rangeData.currentLine
      updatedFormat.itemValue.content = current.content;
      updatedFormat.itemValue.currentValue = current.currentContentValue;
      updatedFormat.itemValue.forceRender = !format.itemValue.forceRender;
      

      let isLast = getAllLines(content)[ type == breakLineId ? rangeData.start.line + 1 : rangeData.start.line].nextSibling == null
      
      updatedFormat.itemValue.scroll["top"] = isLast ? rangeData.addLine + content.scrollTop : content.scrollTop 
    
      

      return {updatedFormat, isSelect:isSelect, isLinkType:isLinkType};
    }
    
    
  }

  const refreshLineId =(newValues) => {
    let content = getAllContent()
    let lines = getAllLines(content)
    
    newValues.map(value => {  
      if (value.source.id != undefined){
        
        value.source.id = lines[value.source.line].id
      }
      else
        value.source.map( item=>{
          item.id = lines[item.source.line].id
        }) 
      value.destination.id = lines[value.destination.line].id
    })

    
  }


 const getRangesByLine = (type, source, destination, startOffset, endOffset) => {
    return [{ type: [type], source: source, destination: destination, start: startOffset , end: endOffset }]
  }

  const getRanges = (type, source, destination, startOffset, endOffset) => {
    if (isLineStyleType([type]) || isListStyleType([type]))
      return getRangesByLine(type, source, destination, startOffset, endOffset)
    else
     return [...(new Array(endOffset - startOffset))].map((_, item) => {
      return { type: [type], source: source, destination: destination, start: startOffset + item, end: startOffset + item + 1 }
    })
    
  }

  const getFormatedValue = (types, value, id) => {
    var currentId = id + 1
    let fontTypes = [];
    
    types = extractFontStyle(types, fontTypes)
   
    types.map(item => {
      id = id + 1
      const type = extractIds(item).type
      if (type == linkId) {
        value = getFormat(type, value, id, {extractUrlId : extractUrlIds(item).id})
      }
      else        
        value = getFormat(type, value, id)
    })

    if (fontTypes.length != 0) {
      let fontStyle = {}
      id = id + 1
      fontTypes.map(fontType => {
        getFormat(fontType.type, fontStyle, id, {font : fontType.font} )
      })
      
      value = <span id = {id} style = {fontStyle}>{value}</span>
    }
    return {formated: value, id: id, currentId:currentId}
  }

  const extractIds = (id) => {
    id = id + ""
    let type = parseInt(id.slice(0,2))
    let font = undefined
    
    if (fontTypes.includes(type))
    // Concat font like the first two char for type then one char for typefonf then last char for value type
      font = {fontId: parseInt(id.slice(2,3)), itemId:parseInt(id.slice(3, id.length))}
    
    return {type : type, font: font} 
  }

  const extractUrlIds = (id) => {
    id = id + ""
    return {type : parseInt(id.slice(0,2)), id: parseInt(id.slice(2,id.length))} 
  }

  const getFormat = (type, value, id, style = undefined) => {
    
    switch (type) {
      case -1:
        return <span style={{ width: value == "" ? "100%" : "auto" }} id={id} 
        /*onClick={(e) => {setCurrentSelection(e);}}*/ >{value}</span>;
      case 0:
        return <strong id={id} 
        >{value}</strong>;
      case 1:
        return <em id={id}
        >{value}</em>;
      case 2:
        return <u id={id}
        >{value}</u>;
      case 3:
        return <del id={id}
        >{value}</del>;
      case 4:
        return <q id={id}
        >{value}</q>;
      case 5:         
        return <ul>{value}</ul>;
      case 6:
        return <ol>{value}</ol>;
      case 7:
        value["textAlign"] = "left" ;
        return value;
      case 8:
        value["textAlign"] = "right" ;
        return value;
      case 9:
        value["textAlign"] = "justify" ;
        return value;
      case 10:
        value["textAlign"] = "center" ;
        return value;
      case 11:
        return;
      case 12:
        return;
      case 13:
        let hrefValue = newHref
        if (!hrefValue)
          hrefValue = format.itemValue.urls.data.filter(data => data.id == style.extractUrlId)[0].item
        return <a id={id} href={hrefValue}>{value}</a>;
      case 14:
        value["fontFamily"] = format.fonts.fontFamily.values
        .filter(value => value.id == style.font.itemId).map(value => value.item)[0] ;
        break;
      case 15:
        value["fontSize"] = format.fonts.fontSize.values
        .filter(value => value.id == style.font.itemId).map(value => value.item)[0] ;
        break;
      case 16: 
        value["color"] = format.fonts.color.values
        .filter(value => value.id == style.font.itemId).map(value => value.item)[0]
        break;
      case 17:
        return <span id={id}>{value}</span>;
      case 18:
        return <span id={id}>{"    "}</span>;
      case 19:
          return <span style={{ width: value == ""?"100%":"auto"}} id={id} ></span>
      case 20:
        return <li >{value}</li>;
      case variableStyleId:
        return <span style={{ color: "green" }} id={id} 
        /*onClick={(e) => {setCurrentSelection(e);}}*/ >{value}</span>;
    }
  }

 
  const getTopValue = (top) => {
    
    var content = getAllContent()
    return top + content.scrollTop + window.scrollY
  }

  const getLinePosition = (childNodes, destinationOffset) => {
    return destinationOffset >= childNodes.length ?  childNodes.length-1 : destinationOffset
  }

  const removeUnknowsElements = (content) => {
    
    Array.from(content.childNodes).filter(child => child.id == "")
    .map(child => content.removeChild(child))

  }

  const setCurrentStyle = () => {
    
    
      if (alreadySetCurrentStyle) return
      setCurrentSelection()
    
      let range =  {startOffset:currentSelection.startOffset , endOffset:currentSelection.endOffset}
      let selection = {anchorNode:currentSelection.anchorNode , focusNode:currentSelection.focusNode}

    
      var rangeValue = getRangeValue(range, selection)
      let selectedsIds = getSelectedIds(rangeValue) //getCurrentStyle(rangeValue)
    
      if (format.itemValue.selectedsIds.filter(id => !selectedsIds.includes(id)).length > 0 
      || selectedsIds.filter(id => !format.itemValue.selectedsIds.includes(id)).length) {

        var updatedFormat = JSON.parse(JSON.stringify(format));
        updatedFormat.itemValue.selectedsIds = selectedsIds
        updatedFormat.itemValue.content = format.itemValue.content
      
        setFormatWithHistorical(updatedFormat)
      }
   
      alreadySetCurrentStyle = true ;
  
  }
  const setCurrentSelection = (isTypingText = false) => {

    
    let selection = window.getSelection();
    let range = selection.getRangeAt(0);
    let isLinkLastPosition = false
    let previousSelection = undefined
         
    if (selection.isCollapsed){ 
      let isAncestor = selection.anchorNode.id == ContentId || selection.focusNode.id == ContentId
      let isUnKnow = selection.anchorNode.id == "" || selection.focusNode.id == ""
      if (isAncestor|| isUnKnow) { 
        let content = getAllContent()
        removeUnknowsElements(content)
        
        let childNodes = content.childNodes
        
        if (childNodes.length == 0 ||  isUnKnow)  return
               
        let anchorNode = getLeafChild(childNodes[getLinePosition(childNodes, selection.anchorOffset)])
        let startOffset = anchorNode.textContent.length
        let focusNode = getLeafChild(childNodes[getLinePosition(childNodes,selection.focusOffset)])
        let endOffset = focusNode.textContent.length
        currentSelection = { anchorNode:anchorNode, startOffset:startOffset, focusNode: focusNode, endOffset: endOffset   } 
        setCurrentRange(anchorNode,startOffset,focusNode,endOffset)
        
      }
      else {
       
          if (isTypingText && isLinkInSelectedIds()) {
            
            isLinkLastPosition = range.startOffset == selection.anchorNode.textContent.length
            previousSelection = { startOffset: currentSelection.startOffset, 
              anchorNodeLeft: currentSelection.anchorNode.parentElement.getBoundingClientRect().left,
              endOffset: currentSelection.endOffset, 
              focusNodeLeft: currentSelection.focusNode.parentElement.getBoundingClientRect().left } 
          }
          let anchorNode = getLeafChild(selection.anchorNode)
          let focusNode = getLeafChild(selection.focusNode)
          let startOffset = selection.anchorNode.innerHTML ? anchorNode.textContent.length : range.startOffset
          
          let endOffset = selection.focusNode.innerHTML ? focusNode.textContent.length : range.endOffset
        
          currentSelection = { anchorNode:anchorNode, startOffset:startOffset, focusNode: focusNode, endOffset: endOffset   }
        //setCurrentRange(anchorNode,startOffset,focusNode,endOffset)
         
      }      
    }
    else {
      setValidCurrentSelection(selection, range)
    } 
    
    currentSelection["previousSelection"] = previousSelection
    currentSelection["isCollapsed"] = selection.isCollapsed
    currentSelection["isLinkLastPosition"] = isLinkLastPosition

  }
  
  const isAnchorNodeBeforeAfter = (anchorNode, focusNode) => {
    let anchorNodeLine = getDivLineById(getLine(anchorNode).id).line
    let focusNodeLine = getDivLineById(getLine(focusNode).id).line
    
    return anchorNodeLine < focusNodeLine
  }

  const setValidCurrentSelection =(selection, range) => {
     
    let isAnchorNodeEmpty = selection.anchorNode.textContent.length == 0
    
    let isFocusNodeEmpty = selection.focusNode.textContent.length == 0
    let isMultiLigne = getLine(selection.anchorNode).id == getLine(selection.focusNode).id
    
    if (!isAnchorNodeEmpty || !isFocusNodeEmpty) {
      let anchorNode = selection.anchorNode
      let focusNode = selection.focusNode
      

      if (isAnchorNodeEmpty) {
        if (isAnchorNodeBeforeAfter(anchorNode, focusNode))
          currentSelection = { anchorNode:focusNode, startOffset:0 ,
          focusNode: focusNode, endOffset:range.endOffset   }
        else 
          currentSelection = { anchorNode:focusNode, startOffset:range.startOffset  ,
          focusNode: focusNode, endOffset:focusNode.textContent.length   }

      }
      else if (isFocusNodeEmpty) {
        if (isAnchorNodeBeforeAfter(anchorNode, focusNode)) {
          currentSelection = { anchorNode:anchorNode, startOffset:range.startOffset ,
          focusNode: anchorNode, endOffset:anchorNode.textContent.length }
        }
        else
          currentSelection = { anchorNode:anchorNode, startOffset:0 ,
          focusNode: anchorNode, endOffset:range.endOffset   }
      }
      else {
        currentSelection = { anchorNode:selection.anchorNode, startOffset:range.startOffset ,
        focusNode: selection.focusNode, endOffset:range.endOffset   }
        
      }
    } 
    else 
      currentSelection = { anchorNode:selection.focusNode, startOffset:range.startOffset ,
      focusNode: selection.focusNode, endOffset:range.endOffset   }
     
  }
  const setCurrentSelectionAndCallValidationIfNeeded = (e) => {
    
    setCurrentSelection()
    
    if (keyCode == validationKeyCode ) {  
      e.preventDefault();
      
      if(currentSelection.isCollapsed)
        saveValidation()
      
    }
  }
  const getEmptyContent = () => {
    return getNewLine(getFormat(-1, "", initialId), initialId+1)
  }

  const buildSelectionAndSetRange =()=>{
    var selectionValue = buildSelection()
    setRange(selectionValue)
  }

  const onKeyDown =(ekeyCode, e)=>{
    isCtrlAPressed = false
    keyCode = ekeyCode
    
    let selection = window.getSelection()
    
    if (isDeleteCode() ) {
     
      setCurrentSelection()
      buildSelectionAndSetRange()
    }
    
    if(ekeyCode == ctrlkeyCode)
      isCtrlPressed = true

    else if(isCtrlPressed && ekeyCode == akeyCode) {
      isCtrlAPressed = true
      let lines = getAllLines(getAllContent())
      let iLastLine = lines.length - 1
      let anchorNode = getLeafChild(lines[0].childNodes[0])
      let startOffset = 0
      let iNodesOfLastLine = lines[iLastLine].childNodes.length - 1
      let focusNode = getLeafChild(lines[iLastLine].childNodes[iNodesOfLastLine])
      let endOffset = focusNode.textContent.length
      setCurrentRange(anchorNode,startOffset,focusNode,endOffset)
       
    }
   
    else if(isCtrlPressed && ekeyCode == zkeyCode) {
      e.preventDefault()
      setPrevious()
    }
    else if(isCtrlPressed && ekeyCode == ykeyCode) {
      e.preventDefault()
      setNext()
    }
    else if(isCtrlPressed && ekeyCode == arobasekeyCode && selection.isCollapsed) {
      var updatedFormat = {...format}
      updatedFormat.isArobasePressed = true
      updatedFormat.isCtrlPressed = false
      updatedFormat.itemValue.ranges.keyCode = arobasekeyCode
      setFormat(updatedFormat)
    }
    else if (!isDeleteCode() && !selection.isCollapsed) {
      setCurrentSelection()
      buildSelectionAndSetRange()
      keyCode = deletekeyCode
      replaceSize.firstLineLength = 1
     
    }
    
  }

  const getActualFont = () => {
    var font = JSON.parse(JSON.stringify(format.itemValue.font));
    
    let fontTypesFound = []
    format.itemValue.selectedsIds.map (item => {
      let extractTypeIds = extractIds(item)
      if (fontTypes.includes(extractTypeIds.type)) {
        fontTypesFound.push(extractTypeIds.font.fontId)
        let typeFont = format.fonts.types.filter(type => type.id == extractTypeIds.font.fontId )[0].item
        let fontValue = format.fonts[typeFont].values.filter(value => value.id == extractTypeIds.font.itemId)[0].item
        font[typeFont].value = fontValue
      }
    })

    format.fonts.types.map(type => {
      if (!fontTypesFound.includes(type.id)) 
        font[type.item].value = font[type.item].default
    })
    
    
    return {font: font, fonts:JSON.parse(JSON.stringify(format.fonts))};
  }

  const getLinkSelectedValue = () => {

    var linkStatus = {isSelected: false, value:""}
    
    var idLink = format.itemValue.selectedsIds.filter(id => (id+"").slice(0,2) == 13)[0]

    if (idLink) {
      idLink = extractUrlIds(idLink).id
      
      linkStatus["isSelected"] = true
      linkStatus["value"] = format.itemValue.urls.data.filter(item => item.id == idLink)[0].item

      
    }

    return linkStatus
  }
  /*
  const insertTextAtCaret = (text) => {
    var sel, range;
    if (window.getSelection) {
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0);
            range.deleteContents();
            range.insertNode( document.createTextNode(text) );
        }
    } else if (document.selection && document.selection.createRange) {
        document.selection.createRange().text = text;
    }
    
  }
  */
  
  
  const onPaste = (e, value = undefined, settings = undefined) => {
    
    var textByLine = value
    if (e) {
      e.preventDefault()
      textByLine = e.clipboardData.getData('text/plain').split(/\r\n|\n\r|\n|\r/g)
    }
    const n = textByLine.length
        
    setRange()
    if (!curentRanges.isCollapsed) {
      if (e) e.stopPropagation();
      return
    }
    
    
    let actualDivItem = getLine(currentSelection.anchorNode)
    let nexItem = actualDivItem.nextSibling
    let parent = actualDivItem.parentElement;

    let startText  = actualDivItem.textContent.slice(0, curentRanges.startOffset - (settings ? settings.previousCharToRemoveLength:0))
    let endText  = actualDivItem.textContent.slice(curentRanges.startOffset, actualDivItem.textContent.length)
    let lastPastLength = textByLine[n-1].length
    
    const shiftDetail = settings ? settings.shiftDetail : {nLine : n -1, startOffset:curentRanges.startOffset + 1
      , endShift: n == 1 ? lastPastLength : lastPastLength - curentRanges.startOffset, isStartAndEndOnSameLine: n == 1}
    
    
    let newItem = undefined
    
    textByLine.map((line, index) => {  
        
        const id = `Line${props.data.id}${index}`
        if (n-1 == 0) {
          newItem = document.createElement("span");
          newItem.textContent = startText + line + endText;
          
          newItem.setAttribute("id", `New${props.data.id}${index}`)
          Array.from(actualDivItem.childNodes).map(child => actualDivItem.removeChild(child))
          actualDivItem.appendChild(newItem)
        }
        else if (index == 0) {
          let prevItem = document.createElement("span");
          prevItem.textContent = startText
          prevItem.setAttribute("id", `Prev${props.data.id}${index}`)

          newItem = document.createElement("span");
          newItem.textContent = line;
          newItem.setAttribute("id", `New${props.data.id}${index}`)

          Array.from(actualDivItem.childNodes).map(child => actualDivItem.removeChild(child))
          actualDivItem.appendChild(prevItem)
          actualDivItem.appendChild(newItem)
        }
        else if (index == n-1) {
          const addLine = 21
          nexItem = actualDivItem.nextSibling
          parent = actualDivItem.parentElement
          
          newItem = document.createElement("div");

          let prevItem = document.createElement("span");
          prevItem.textContent = endText
          prevItem.setAttribute("id", `Prev${props.data.id}${index}`)

          let newSpan = document.createElement("span");
          newSpan.textContent = line;
          newSpan.setAttribute("id", `New${props.data.id}${index}`) 

          
          newItem.appendChild(newSpan);
          newItem.appendChild(prevItem);
          newItem.setAttribute("id", id)
          newItem.setAttribute("style", `display: flex; white-space: pre; min-height: ${addLine}px`)
          parent.insertBefore(newItem, nexItem)

          actualDivItem = document.getElementById(id)  
        }
        else
        {
          const addLine = 21
          nexItem = actualDivItem.nextSibling
          parent = actualDivItem.parentElement
          newItem = document.createElement("div");
          let spanElement = document.createElement("span");
          spanElement.textContent = line;
          newItem.appendChild(spanElement);
          newItem.setAttribute("id", id)
          newItem.setAttribute("style", `display: flex; white-space: pre; min-height: ${addLine}px`)
          parent.insertBefore(newItem, nexItem)
          actualDivItem = document.getElementById(id)
        }  
        
    })
    
    saveInput(shiftDetail, true)
     
  }

  const onkeyUp  = (e) => {
    if(!isCtrlAPressed ) {
      {setCurrentSelection(); setCurrentStyle(); alreadySetCurrentStyle = false ;}
    } 
    if (e.keyCode == ctrlkeyCode || (e.keyCode != zkeyCode && e.keyCode != ykeyCode && e.keyCode == akeyCode && e.keyCode == xkeyCode)) { 
      if (format.isCtrlPressed) setFormat({...format, isCtrlPressed : false})
    } 
  }
  
  const onSaveSelection = (e, selectedsItems) => {
    setSelection();

    const value =  "{{" + getValueFromArray(selectedsItems.checkeds).name + "}}"
    const startOffset = curentRanges.startOffset - 1
    const endOffset = curentRanges.endOffset - 1
    const textLength = value.length 
    const previousCharToRemoveLength = 1
    const settings = {
      shiftDetail : {nLine : 0, startOffset:startOffset + 1, endShift: textLength - previousCharToRemoveLength , isStartAndEndOnSameLine: true},
      previousCharToRemoveLength:previousCharToRemoveLength
    }
    
    callBackDetails = {startOffset:startOffset, line:curentRanges.start.line , endOffset:endOffset + textLength, length:textLength
      , parameters:{type:variableStyleId, checkedDetail : {value:value, checkeds:selectedsItems.checkeds}}}

    onPaste(undefined, [value], settings)       

    
  }
  const getTreeViewDialog  = () => {
    return <TreeViewDialog  
      onSaveSelection = {(e, selectedsItems) =>  onSaveSelection(e, selectedsItems)} //onSaveSelection(e, selectedsItems, fieldId)
      onClose = {() => setFormat({...format, isArobasePressed:false})} //onClickEditOperand(undefined, type)
      withCheckBox = {true}
      data = {props.modalData} 
      title = {props.customModalTitle}
      customData = {props.customModalData}
      parentId = {props.modalParentId} 
      type = {props.modalType} />
    
  }
  
 
  return (
    <React.Fragment>
      
        {format.isArobasePressed && getTreeViewDialog()}
    
    <div key={format.itemValue.forceRender} style={{ width: "100%", marginBottom:"10px", height:"100%" }} >
      {!props.hideToolBar && <EditorStyles linkStatus = {getLinkSelectedValue()}
  
        selecteds={format.itemValue.selectedsIds} 
        isPreviousEnabled={format.isPreviousEnabled} 
        isNextEnabled={format.isNextEnabled} 
        id={"ToolBar" + props.data.id }
        width = {"500px"}  
        styleFont = {getActualFont()}
        nextUrlId = {format.itemValue.urls.nextId}
        onClickItem = { (itemSelected) => onClickItem(itemSelected) } />}
        
      <div  onInput={(e) => { if (keyCode != validationKeyCode) saveInput(undefined, undefined, e );   }} 
            onDrop = {(e) => { e.preventDefault(); return;   }} 
            onKeyPress={(e) => { setCurrentSelectionAndCallValidationIfNeeded(e);  } }
            onMouseLeave={(e) => { if(!isCtrlAPressed) setRange(undefined,e)}} 
            onKeyDown={(e) => {  isCtrlAPressed = false; onKeyDown(e.keyCode,e)}}
            onKeyUp={(e) => onkeyUp(e)}
            onPaste = {(e) => onPaste(e)}
            onClick = {() => { isCtrlAPressed = false; setCurrentStyle();  }}
            onMouseMove={() => { alreadySetCurrentStyle = false ;}}
            onDoubleClick = {(e) => { e.stopPropagation(); alreadySetCurrentStyle = true ; }}
            id={ContentId} contentEditable={true} spellCheck={false}
            style={{ //width: "500px", 
              //height: parseInt(props.style.height.slice(0,-2)) - 27 + "px",
             
              minHeight: parseInt(props.style.height.slice(0,-2)) - 27 + "px",
              backgroundColor: "white"
            , overflowY: "auto", outline: "0px solid transparent", border: props.style.border
            , fontFamily: format.itemValue.font.fontFamily.default
            , fontSize: format.itemValue.font.fontSize.default
            , color: format.itemValue.font.color.default
            //, resize :"both"
             
           }}
           
           >
        {format.initialValue ? null: 
          format.itemValue.content == null? getEmptyContent():format.itemValue.content }
       
      </div>
     
    </div>
    </React.Fragment>
  );
}
